import { Task, Timestamp, WeekDays } from '@griply/types';
import { getTaskPlannedOccurrenceForDate } from '@griply/utils';
import { useMemo } from 'react';

export type UseTaskPlannedOccurrenceForDateOptions = {
  weekStartsOn: WeekDays;
  today: Timestamp;
  uncompletedOnly?: boolean;
};

export const useTaskPlannedOccurrenceForDate = (
  task: Task,
  date: Timestamp,
  {
    weekStartsOn,
    today,
    uncompletedOnly,
  }: UseTaskPlannedOccurrenceForDateOptions,
  enabled = true,
) =>
  useMemo(
    () =>
      enabled
        ? getTaskPlannedOccurrenceForDate(task, date, {
            weekStartsOn,
            today,
            uncompletedOnly,
          })
        : undefined,
    [date, task, today, weekStartsOn, uncompletedOnly, enabled],
  );
